import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const SidebarContainer = styled.aside<{
  iscollapsed: boolean;
  navbarbg: string;
}>`
  width: ${({ iscollapsed }) => (iscollapsed ? '64px' : '236px')};
  min-width: ${({ iscollapsed }) => (iscollapsed ? '64px' : '236px')};
  background-color: ${({ navbarbg }) => navbarbg};
  color: #e0e0e0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  transition: width 0.3s ease-in-out;
  position: sticky;
  top: 0;
  left: 0;
`;

export const SidebarHeader = styled.div<{ iscollapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ iscollapsed }) =>
    iscollapsed ? 'center' : 'space-between'};
  padding: 0 24px;
  height: 64px; // Standard header height
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .logo-text {
    display: ${({ iscollapsed }) => (iscollapsed ? 'none' : 'block')};
    font-size: 1.5rem;
    font-weight: bold;
    color: #fff;
  }
`;

export const MenuButton = styled.button<{ navbarhovercolor: string }>`
  background: none;
  border: none;
  color: #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 6px;
  border-radius: 4px;

  &:hover {
    --background-color: rgba(255, 255, 255, 0.1);
    text-decoration: underline;
    color: ${({ navbarhovercolor }) => navbarhovercolor};
  }
`;

export const NavList = styled.nav`
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 0 16px 0;
  overflow-x: hidden;
`;

export const SubItemsContainer = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) =>
    isOpen ? '500px' : '0'}; // Animates the opening/closing
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.2);
`;

const itemStyles = css<{
  iscollapsed?: boolean;
  level: number;
  navbaractivebg: string;
  navbaractivesubbg: string;
  navbaractivecolor: string;
}>`
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  text-decoration: none;
  color: #e0e0e0;
  white-space: nowrap;
  overflow: hidden;
  gap: 16px;
  max-width: ${({ iscollapsed }) => (iscollapsed ? '64px' : '236px')};

  &:link,
  &:visited,
  &:hover,
  &:active {
    color: #e0e0e0;
  }

  ${({ iscollapsed }) =>
    !iscollapsed &&
    css`
      text-wrap: wrap;
      --overflow-wrap: break-word;
      --word-wrap: break-word;
      --word-break: break-all;
    `}

  .sidebar-label {
    opacity: ${({ iscollapsed }) => (iscollapsed ? 0 : 1)};
    transition: opacity 0.3s ease-in-out;
    font-size: 0.875rem;
    color: inherit;
  }

  .sidebar-icon {
    flex-shrink: 0;
    color: inherit;
  }

  .chevron {
    margin-left: auto;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    opacity: ${({ iscollapsed }) => (iscollapsed ? 0 : 1)};
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  &.active {
    background-color: ${({ level, navbaractivebg, navbaractivesubbg }) =>
      level === 0 ? navbaractivebg : navbaractivesubbg};
    color: ${({ navbaractivecolor }) => navbaractivecolor};
    font-weight: 500;
  }

  &.active:link,
  &.active:visited,
  &.active:hover,
  &.active:active {
    color: ${({ navbaractivecolor }) => navbaractivecolor};
  }
`;

export const ItemWrapper = styled.div<{
  iscollapsed?: boolean;
  level: number;
  alreadyinflyout?: boolean;
  navbaractivebg: string;
  navbaractivesubbg: string;
  navbaractivecolor: string;
}>`
  ${itemStyles}
  padding-left: ${({ level, alreadyinflyout }) =>
    alreadyinflyout ? 24 : 24 + level * 20}px;
`;

export const ItemLink = styled(NavLink)<{
  iscollapsed?: boolean;
  level: number;
  alreadyinflyout?: boolean;
  navbaractivebg: string;
  navbaractivesubbg: string;
  navbaractivecolor: string;
}>`
  ${itemStyles}
  padding-left: ${({ level, alreadyinflyout }) =>
    alreadyinflyout ? 24 : 24 + level * 20}px;
  ${({ iscollapsed, level }) =>
    !iscollapsed &&
    level > 0 &&
    css`
      border-top: 1px solid rgba(255, 255, 255, 0.05);
    `}
`;

export const SidebarFooter = styled.div`
  padding: 16px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;
